<template>
  <div class="form-item">
    <label v-if="label" class="label">{{ label }}</label>
    <input
      :type="type"
      class="input"
      :value="model"
      :placeholder="placeholder"
      required
      :disabled="disabled"
      @input="handleInput"
      :autocomplete="autocomplete"
    />
    <small v-if="error" class="error">{{ error }}</small>
  </div>
</template>

<script>
/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";

export default {
  name: "ArnergySelect",
  props: {
    model: null,
    placeholder: null,
    label: null,
    disabled: false,
    autocomplete: '',
    type: null,
    error: null
  },
  computed: {},
  data() {
    return {};
  },
  methods: {
    handleInput(event) {
      this.$emit("input", event.target.value);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/_reduced_variables.scss";
.form-item {
  margin-bottom: 20px;

  label {
    margin-bottom: 10px;
    color: #999;
    font-size: 14px;
    padding: 0;
    font-weight: 400;
    display: block;
    text-align: left;
  }

  .select-input {
    border: 1px solid #cccccc;
    width: 100%;
    padding: 10px 20px;
    height: 50px;
  }

  input,
  .input {
    width: 100%;
    display: block;
    height: 50px;
    background: white !important;
    padding: 20px;
    font-weight: bold;
    border: 1px solid #cccccc;
  }

  .error {
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/kitchen/ArnergyInput.vue